import * as S from './NudgeBar.styles';
import makeComp from '../util/profiler';
import {Link} from 'react-router-dom';
import React from 'react';
import LegacyWBIcon from './elements/LegacyWBIcon';

type NudgeBarProps = {
  mainText: string;
  linkText?: string;
  link?: string;
  showDismissOption?: boolean;
  onClose?(): void;
};

const NudgeBar: React.FC<NudgeBarProps> = makeComp(
  (props: NudgeBarProps) => {
    return (
      <>
        <S.Nudge>
          <S.NudgeInner>
            <S.NudgeMessage>{props.mainText}</S.NudgeMessage>
            {props.linkText != null && props.link != null && (
              <S.NudgeLink>
                <Link className="nudge-info-link" to={props.link}>
                  {props.linkText}
                </Link>
              </S.NudgeLink>
            )}
          </S.NudgeInner>
          <S.NudgeDismiss>
            {props.showDismissOption != null && (
              <LegacyWBIcon
                name="close"
                className="close-button"
                onClick={props.onClose != null ? props.onClose : () => ({})}
                size="large"
              />
            )}
          </S.NudgeDismiss>
        </S.Nudge>
      </>
    );
  },
  {id: 'NudgeBar', memo: true}
);

export default NudgeBar;
